import type { FunctionComponent, PropsWithChildren } from 'react'

import classnames from 'classnames'

import styles from './GridArticle.module.scss'

export type GridArticleProps = PropsWithChildren<{
  className?: string
  templateName?: string
  bypass?: boolean
}>

export const GridArticle: FunctionComponent<GridArticleProps> = ({ className, children, bypass = false }) => {
  return bypass ? (
    <>{children}</>
  ) : (
    <GridArticleRenderer className={className}>{children}</GridArticleRenderer>
  )
}

const GridArticleRenderer: FunctionComponent<GridArticleProps> = ({ className, children }) => (
  <section data-testid="grid-article" className={classnames(styles.grid, className)}>
    {children}
  </section>
)
